 
import { call, select, take, takeLatest } from 'redux-saga/effects';
import {
  actions,
  selectClinicalTrialTeamPageState,
} from './ClinicalTrialTeamPage.slice';
import { selectClinicalTrial } from '../clinicalTrial/clinicalTrial.slice';
import {
  deleteTeamMember,
  deleteTeamMemberSuccess,
  deleteTeamMemberFailure,
  fetchTeamMembersList,
} from '../teamMembersList/teamMembersList.slice';
import { PayloadAction } from '@reduxjs/toolkit';
import { selectPaginationAndSort } from '../paginationAndSort/paginationAndSort.slice';
import { PaginationAndSortState } from '../paginationAndSort/paginationAndSort.types';
import { selectTeamFiltersState } from '../teamFilters/teamFilters.slice';
import { TeamFiltersState } from '../teamFilters/teamFilters.types';
import { ClinicalTrialState } from '../clinicalTrial/clinicalTrial.types';
import { dispatch } from '../helpers';
import { selectAuthState } from '../auth/auth.slice';
import { goToRoute } from '../tools';
import { routesPath } from 'src/router/routes';

export function* confirmActionWithMemberWorker() {
  const {
    currentModal,
    currentTeamMember,
    searchValue,
  }: ReturnType<typeof selectClinicalTrialTeamPageState> = yield select(
    selectClinicalTrialTeamPageState
  );

  const { data }: ClinicalTrialState = yield select(selectClinicalTrial);

  const clinicalTrialId = data?.id as string;

  if (!clinicalTrialId) {
    yield call(console.log.bind(console), 'No clinical trial id found');
  }

  if (['ACTIVATE_MEMBER', 'SUSPEND_MEMBER'].includes(currentModal as string)) {
    yield dispatch(actions.setAddEditMemberModalOpen(true));
  }

  if (currentModal === 'DELETE_MEMBER') {
    yield dispatch(
      deleteTeamMember({
        clinicalTrialId,
        teamMemberId: currentTeamMember?.id as string,
      })
    );
    const deleteMemberFinishAction: PayloadAction = yield take([
      deleteTeamMemberSuccess.type,
      deleteTeamMemberFailure.type,
    ]);

    const authState: ReturnType<typeof selectAuthState> =
      yield select(selectAuthState);

    const isOwner =
      authState?.data?.['dynamika7/user_metadata']?.uuid ===
      currentTeamMember?.id;

    if (
      deleteMemberFinishAction.type === deleteTeamMemberSuccess.type &&
      !isOwner
    ) {
      const paginationAndSortState: PaginationAndSortState = yield select(
        selectPaginationAndSort
      );
      const { selectedFilters }: TeamFiltersState = yield select(
        selectTeamFiltersState
      );
      const { currentPage, currentPageSize, sortBy } =
        paginationAndSortState.lists.teamMembers;

      const sort = sortBy ?? undefined;
      yield dispatch(
        fetchTeamMembersList({
          clinicalTrialId,
          args: {
            sort,
            size: currentPageSize,
            page: currentPage,
            search: searchValue,
            institution: selectedFilters?.institution?.[0],
            role: selectedFilters?.role?.[0],
            siteCode: selectedFilters?.site?.[0],
          },
        })
      );
    }
    yield dispatch(actions.setCurrentModal(undefined));
    yield dispatch(actions.setAddEditMemberModalOpen(false));

    if (isOwner) {
      yield goToRoute(routesPath.clinicalTrials);
    }
  }
}

export function* ClinicalTrialTeamPageSaga() {
  yield takeLatest(
    actions.confirmActionWithMember.type,
    confirmActionWithMemberWorker
  );
}
